export function getEventCapacity(event) {
  const isSeated = event.venueLayout?.sections?.length > 0;

  let total, sold;
  if (isSeated) {
    total = event.venueLayout.sections.reduce(
      (sum, s) => sum + (s.rowCount || 0) * (s.seatsPerRow || 0), 0
    );
    sold = event.soldSeats?.length || 0;
  } else {
    total = event.tickets?.reduce((sum, t) => sum + t.quantity, 0) || 0;
    sold = event.tickets?.reduce((sum, t) => sum + (t.sold || 0), 0) || 0;
  }

  const available = total - sold;
  const percentage = total > 0 ? Math.round((sold / total) * 100) : 0;

  return { total, sold, available, percentage };
}

export function getSeatInfo(seatId, sections, seatPricing) {
  for (const section of sections) {
    for (const row of section.rows || []) {
      const seat = row.seats?.find(s => s.id === seatId);
      if (seat) {
        const override = seatPricing?.find(p => p.seatIds?.includes(seatId));
        return {
          sectionName: section.name,
          rowLabel: row.label,
          number: seat.number,
          price: override?.price || section.price,
          color: section.color,
        };
      }
    }
  }
  return null;
}
